import { SLP_PAGE_REDUCER_KEY } from '@tcp/core/src/constants/reducer.constants';
import { getInitialValues } from '../../CategoryListingPage/container/CategoryListingPage.selectors';
import { getInitialFilterValues } from '../../SearchDetail/container/SearchDetail.selectors';

const getPlpState = (state) => state?.CategoryListingPage;
const getSlpState = (state) => {
  return state[SLP_PAGE_REDUCER_KEY];
};

const getIsBopisFilterOn = (state, ownProps) => {
  const plpState = getPlpState(state);
  const slpState = getSlpState(state);
  const { pathName } = ownProps;
  if (pathName && (pathName.includes('search') || pathName.includes('featurebrand')))
    return slpState.isBopisFilterOn;
  return plpState.isBopisFilterOn;
};

export const getFormValuesForOneHrFilter = (state, ownProps) => {
  const plpFormValues = getInitialValues(state);
  const slpFormValues = getInitialFilterValues(state);
  const { pathName } = ownProps;
  if (pathName && (pathName.includes('search') || pathName.includes('featurebrand')))
    return slpFormValues;
  return plpFormValues;
};

export default getIsBopisFilterOn;
